import { render, staticRenderFns } from "./EmailMarketingPanel.vue?vue&type=template&id=6cd9355e&scoped=true"
import script from "./EmailMarketingPanel.vue?vue&type=script&lang=js"
export * from "./EmailMarketingPanel.vue?vue&type=script&lang=js"
import style0 from "./EmailMarketingPanel.vue?vue&type=style&index=0&id=6cd9355e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9355e",
  null
  
)

export default component.exports